const metaEnv = import.meta.env;
export const MODE = metaEnv?.MODE || 'production';
export const ENV = metaEnv?.REACT_APP_ENV;
export const AUTH0_DOMAIN = metaEnv?.REACT_APP_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = metaEnv?.REACT_APP_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = metaEnv?.REACT_APP_AUTH0_AUDIENCE;
export const API_GATEWAY_URL = metaEnv?.REACT_APP_API_GATEWAY_URL;
export const MIXPANEL_TOKEN = metaEnv?.REACT_APP_MIXPANEL_TOKEN;
export const FORCE_MIXPANEL = metaEnv?.REACT_APP_FORCE_MIXPANEL === 'true';
export const HATSULY_URL = metaEnv?.REACT_APP_HATSULY_URL;
export const HATSULY_DASHBOARD_URL = metaEnv?.REACT_APP_HATSULY_DASHBOARD_URL;
export const MARKLY_URL = metaEnv?.REACT_APP_MARKLY_URL;
export const CAPTURE_URL = metaEnv?.REACT_APP_CAPTURE_URL;
